import React from "react";
import { Field, reduxForm, useReduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderTextField } from "../../../Components/Forms/renders";
import MultiSelect from "../../../Components/Forms/multiselect";
import RichTextMarkdown from "../../../Components/Forms/wysiwyg";


let BedrijvenVacatureForm = (props) => {
  const { handleSubmit, change } = props;

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <Field name="titel" type="input" component={renderField} label="Kies een title voor de vacature" validate={[required()]}  />
              <Field name="beschrijving" type="input" component={RichTextMarkdown} label="Vul korte bedrijving van je de vacature" validate={[required()]}  />
              <Field
                name="afdeling"
                type="input"
                component={MultiSelect}
                options={["recreatie","horeca","groen","techniek","schoonmaak","administratie","beveiliging","zorg","overig","animatie"]}
                label="Kies een afdeling"
              />
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Aanmaken" />
          </div>
        </div>
      </form>
    </div>
  );
};

BedrijvenVacatureForm = reduxForm({
  form: "bedrijfinsert", // a unique identifier for this form
})(BedrijvenVacatureForm);

BedrijvenVacatureForm = connect()(BedrijvenVacatureForm);

export default BedrijvenVacatureForm;
